module.exports = __webpack_public_path__ + "a35e64a232ad47f8b807cf8201eb58c3.svg";